<button type="button" class="floating-cart-button" (click)="openCart()" aria-label="باز کردن سبد خرید" [attr.aria-label]="itemCount ? 'سبد خرید، ' + itemCount + ' کالا' : 'باز کردن سبد خرید'">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 4h2l1.6 11.1a2 2 0 0 0 2 1.7h7.8a2 2 0 0 0 1.9-1.4L20 8H6" />
    <circle cx="10" cy="20" r="1.3" /><circle cx="17" cy="20" r="1.3" />
  </svg>
  @if (itemCount > 0) {
    <span class="floating-cart-count">{{ itemCount | persianNumber }}</span>
  }
  <span class="floating-cart-label">سبد خرید</span>
</button>
